const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  collaboratorsData: [],
  filteredCollaboratorsData: [],
  backupCollaboratorsData: [],
  avatars: {
    etching: false,
    fetched: false,
    error: null,
    items: []
  },
  collaborator: null,
  settingSuggestions: {
    data: null,
    fetching: false,
    fetched: false,
    error: null
  },
  nbResult: 0,
  filter: {
    label: "",
    zone: null,
    bu: null,
    regime: null,
    role: null
  },
  gdNotifications: null,
  error: null
};

export const collaboratorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_COLLABORATOR": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        collaboratorsData: [],
        filteredCollaboratorsData: [],
        error: null
      };
    }
    case "FETCH_SETTING_COLLABORATORS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_SETTING_COLLABORATORS_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        nbResult: data.nbResult,
        collaboratorsData: data,
        filteredCollaboratorsData: data
      };
    }
    case "FETCH_SETTING_COLLABORATORS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        collaboratorsData: [],
        filteredCollaboratorsData: [],
        error
      };
    }
    case "FETCH_COLLABORATOR_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_COLLABORATOR_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        collaborator: data.data.data
      };
    }
    case "FETCH_COLLABORATOR_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        collaborator: null,
        error
      };
    }
    case "FETCH_COLLABORATOR_SETTING_SUGGESTIONS_PENDING": {
      let settingSuggestions = {
        ...state.settingSuggestions,
        fetched: false,
        fetching: true
      };
      return { ...state, settingSuggestions };
    }
    case "FETCH_COLLABORATOR_SETTING_SUGGESTIONS_FULFILLED": {
      const settingSuggestions = {
        ...state.settingSuggestions,
        data: action.payload.data.data,
        fetched: true,
        fetching: false
      };
      return {
        ...state,
        settingSuggestions
      };
    }
    case "FETCH_COLLABORATOR_SETTING_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_COLLABORATOR_SETTING_FILTER_TITLE": {
      return {
        ...state,
        filter: { ...state.filter, label: action.title }
      };
    }
    case "UPDATE_SETTINGS_COLLABORATOR_PENDING": {
      return { ...state, saving: true };
    }
    case "UPDATE_SETTINGS_COLLABORATOR_FULFILLED": {
      return { ...state, saving: false };
    }
    case "UPDATE_SETTINGS_COLLABORATOR_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return { ...state, error };
    }
    case "DELETE_COLLABORATOR_REGIME_PENDING": {
      return { ...state, deleted: false, deleting: true };
    }
    case "DELETE_COLLABORATOR_REGIME_FULFILLED": {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case "DELETE_COLLABORATOR_REGIME_REJECTED": {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case "DELETE_COLLABORATOR_ROLE_PENDING": {
      return { ...state, deleted: false, deleting: true };
    }
    case "DELETE_COLLABORATOR_ROLE_FULFILLED": {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case "DELETE_COLLABORATOR_ROLE_REJECTED": {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case "DELETE_COLLABORATOR_ZONE_PENDING": {
      return { ...state, deleted: false, deleting: true };
    }
    case "DELETE_COLLABORATOR_ZONE_FULFILLED": {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case "DELETE_COLLABORATOR_ZONE_REJECTED": {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case "DELETE_COLLABORATOR_BU_PENDING": {
      return { ...state, deleted: false, deleting: true };
    }
    case "DELETE_COLLABORATOR_BU_FULFILLED": {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case "DELETE_COLLABORATOR_BU_REJECTED": {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case "DELETE_COLLABORATOR_HOLIDAY_TYPE_PENDING": {
      return { ...state, deleted: false, deleting: true };
    }
    case "DELETE_COLLABORATOR_HOLIDAY_TYPE_FULFILLED": {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case "DELETE_COLLABORATOR_HOLIDAY_TYPE_REJECTED": {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case "SET_COLLABORATOR_SUGGESTIONS_REGIMES": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          data: {
            ...state.settingSuggestions.data,
            regimes: action.payload
          }
        }
      };
    }
    case "SET_COLLABORATOR_SUGGESTIONS_ROLES": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          data: {
            ...state.settingSuggestions.data,
            roles: action.payload
          }
        }
      };
    }
    case "SET_COLLABORATOR_SUGGESTIONS_ZONES": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          data: {
            ...state.settingSuggestions.data,
            zones: action.payload
          }
        }
      };
    }
    case "SET_COLLABORATOR_SUGGESTIONS_BU": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          data: {
            ...state.settingSuggestions.data,
            bus: action.payload
          }
        }
      };
    }
    case "SET_COLLABORATOR_SUGGESTIONS_HOLIDAY_TYPE": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          data: {
            ...state.settingSuggestions.data,
            holidayTypes: action.payload
          }
        }
      };
    }
    case "SAVE_COLLABORATOR_REGIME_PENDING": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: true
        }
      };
    }
    case "SAVE_COLLABORATOR_REGIME_FULFILLED": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false
        }
      };
    }
    case "SAVE_COLLABORATOR_REGIME_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false,
          error
        }
      };
    }
    case "SAVE_COLLABORATOR_ROLE_PENDING": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: true
        }
      };
    }
    case "SAVE_COLLABORATOR_ROLE_FULFILLED": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false
        }
      };
    }
    case "SAVE_COLLABORATOR_ROLE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false,
          error
        }
      };
    }
    case "SAVE_COLLABORATOR_ZONE_PENDING": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: true
        }
      };
    }
    case "SAVE_COLLABORATOR_ZONE_FULFILLED": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false
        }
      };
    }
    case "SAVE_COLLABORATOR_ZONE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false,
          error
        }
      };
    }
    case "SAVE_COLLABORATOR_BU_PENDING": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: true
        }
      };
    }
    case "SAVE_COLLABORATOR_BU_FULFILLED": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false
        }
      };
    }
    case "SAVE_COLLABORATOR_BU_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false,
          error
        }
      };
    }
    case "SAVE_COLLABORATOR_HOLIDAY_TYPE_PENDING": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: true
        }
      };
    }
    case "SAVE_COLLABORATOR_HOLIDAY_TYPE_FULFILLED": {
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false
        }
      };
    }
    case "SAVE_COLLABORATOR_HOLIDAY_TYPE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        settingSuggestions: {
          ...state.settingSuggestions,
          saving: false,
          error
        }
      };
    }
    case "FETCH_COLLABORATOR_AVATARS_PENDING": {
      return {
        ...state,
        avatars: { ...state.avatars, fetching: true }
      };
    }
    case "FETCH_COLLABORATOR_AVATARS_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        avatars: {
          ...state.avatars,
          fetching: false,
          fetched: true,
          error: null,
          items: data
        }
      };
    }
    case "FETCH_COLLABORATOR_AVATARS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        avatars: {
          ...state.avatars,
          fetching: false,
          items: [],
          error
        }
      };
    }

    case "FETCH_GD_NOTIFICATIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_GD_NOTIFICATIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        gdNotifications: action.payload.data
      };
    }
    case "FETCH_GD_NOTIFICATIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_FILTER_ZONE": {
      return {
        ...state,
        filter: {
          ...state.filter,
          zone: action.zone
        }
      };
    }
    case "SET_FILTER_BU": {
      return {
        ...state,
        filter: {
          ...state.filter,
          bu: action.bu
        }
      };
    }
    case "SET_FILTER_ROLE": {
      return {
        ...state,
        filter: {
          ...state.filter,
          role: action.role
        }
      };
    }
    case "SET_FILTER_REGIME": {
      return {
        ...state,
        filter: {
          ...state.filter,
          regime: action.regime
        }
      };
    }
    case "FILTER_COLLABORATORS_DATA": {
      return {
        ...state,
        filteredCollaboratorsData: action.payload
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/collaborator.js